<template>
  <div class="footer">
    <footer>
      <div class="container">
        <div class="content">
          <p class="no-divider">
            © 2025 Porsche Financial Services, Inc.
            <span>
              <router-link to="/legal/terms-of-use">Legal Notice.</router-link>
            </span>
            <span>
              <router-link to="/legal/privacy-policy"
                >Privacy Policy.</router-link
              >
            </span>
            <span>
              <router-link to="/legal/sms">SMS Policy.</router-link>
            </span>
          </p>
          <p class="disclaimer-text no-divider">
            The information provided herein is a general description of policy
            features and benefits. Details may vary by individual or by state.
            Availability, renewability, cancellability, termination, or
            modification of policy features and benefits are exclusively
            governed by the official policy documents. Porsche Auto Insurance is
            offered by Mile Premier LLC, a managing general insurance agency
            with principal offices located at PO Box 725369, Atlanta, GA 31139
            DBA Porsche Auto Insurance, a wholly-owned subsidiary of Mile Auto,
            Inc.
          </p>
          <p class="disclaimer-text no-divider">
            Porsche Financial Services, Inc., Porsche Cars North America, Inc.
            and Porsche AG (along with their affiliates, subsidiaries and
            employees) are not insurance companies or licensed insurance agents,
            and are not selling, soliciting, servicing, or offering advice
            regarding auto insurance products.
          </p>
          <p class="disclaimer-text no-divider">
            Porsche recommends seat-belt usage and observance of traffic laws at
            all times.
          </p>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'Footer'
};
</script>

<style lang="scss" scoped>
div.footer {
  padding: 3rem 0 0;
  background-color: $white;
}
footer {
  background-color: $footer-background-color;
  color: #fff;
  padding: $footer-padding;

  p {
    line-height: 24px;

    @media (min-width: 760px) {
      border-top: 1px solid $abbey;
      padding-top: 24px;
    }

    @media (max-width: 760px) {
      border-top: 1px solid $abbey;
      padding-top: 1rem;
    }

    &.no-divider {
      border-top: 0;
      padding-top: 0;
    }

    span {
      display: block;

      @media (min-width: 760px) {
        display: inline-block;
      }
    }
  }

  a {
    color: inherit;
    cursor: pointer;
    display: inline-block;
    margin-left: 4px;
    text-decoration: underline;
    transition: color 0.24s;

    &:hover {
      color: $base;
    }
  }
  .content {
    padding: 0 2%;
  }
  .disclaimer-text {
    font-size: 12px;
  }
}
</style>
